<template>
  <main class="common-container">
    <section class="page-title flash-title">
      <h2>
        {{ $t("renewal.1%chart.title") }} {{ $t("menu-dropdown.coinList") }}
      </h2>
      <div class="center-sentence-box">
        <!-- <p class="center-sentence" v-html="$t('bubbleExp.descText1')"></p> -->
        <p class="center-sentence">
          {{ $t("coinExp.list2") }}<br />
          {{ $t("coinExp.list4") }}
        </p>
      </div>
    </section>

    <!-- <section class="explanation-container center">
      <img :src="explainImg1" alt="" />
    </section> -->

    <section class="explanation-container center">
      <img :src="explainImg1" alt="" />
      <img :src="coinlistMImg2" alt="" v-if="isMobile" />
      <ul class="color-circle">
        <li class="color-circle__item">
          <p>{{ $t("renewal.coinlistKibotZoneExp.descText1") }}</p>
        </li>
        <li class="color-circle__item">
          <p>{{ $t("coinlistExplorerExp.descText2") }}</p>
        </li>
        <li class="color-circle__item">
          <p>{{ $t("coinlistKibotZoneExp.descText3") }}</p>
        </li>
        <li class="color-circle__item">
          <p>{{ $t("coinlistKibotZoneExp.descText4") }}</p>
        </li>
        <li class="color-circle__item">
          <p>{{ $t("renewal.coinlistKibotZoneExp.descText2") }}</p>
        </li>
        <li class="color-circle__item">
          <p>{{ $t("renewal.coinlistKibotZoneExp.descText3") }}</p>
        </li>
      </ul>
    </section>
    <!-- 
    <section class="explanation-container center last">
      <img :src="explainImg3" alt="" />
      <ul class="color-circle">
        <li class="color-circle__item">
          <p>{{ $t("coinExp.content1.descText1") }}</p>
        </li>
        <li class="color-circle__item">
          <p v-html="$t('coinExp.content1.descText2')"></p>
        </li>
        <li class="color-circle__item">
          <p>{{ $t("coinExp.content1.descText3") }}</p>
        </li>
        <li class="color-circle__item">
          <p>{{ $t("coinExp.content1.descText4") }}</p>
        </li>
        <li class="color-circle__item">
          <p v-html="$t('coinExp.content1.descText5')"></p>
        </li>
        <li class="color-circle__item">
          <p v-html="$t('coinExp.content1.descText6')"></p>
        </li>
        <li class="color-circle__item">
          <p v-html="$t('coinExp.content1.descText7')"></p>
        </li>
        <li class="color-circle__item">
          <p>{{ $t("coinExp.content1.descText8") }}</p>
        </li>
        <li class="color-circle__item">
          <p>{{ $t("coinExp.content1.descText9") }}</p>
        </li>
      </ul>
    </section> -->
  </main>
</template>

<script setup>
import { computed, onMounted, onUnmounted } from "vue";
import { useResolutionStore } from "@/store/useResolution";
// import coinlistImg1 from "@/assets/images/pages/explanation/coinlist/coinlist_explanation1.png";
import coinlistImg1 from "@/assets/images/pages/explanation/coinlist/coinlist_explanation_kibot.png";
import coinlistMImg1 from "@/assets/images/pages/explanation/coinlist/coinlist_explanation_kibot1-m.png";
// import coinlistImg2 from "@/assets/images/pages/explanation/coinlist/coinlist_explanation2.png";
import coinlistMImg2 from "@/assets/images/pages/explanation/coinlist/coinlist_explanation_kibot2-m.png";
// import coinlistImg3 from "@/assets/images/pages/explanation/coinlist/coinlist_explanation3.png";
// import coinlistMImg3 from "@/assets/images/pages/explanation/coinlist/coinlist_explanation3-m.png";

const resolutionStore = useResolutionStore();
const isMobile = computed(() => resolutionStore.isMobile);
// isMobile 값이 변경될 때 자동으로 업데이트됨
const explainImg1 = computed(() =>
  isMobile.value ? coinlistMImg1 : coinlistImg1
);
// const explainImg2 = computed(() =>
//   isMobile.value ? coinlistMImg2 : coinlistImg2
// );
// const explainImg3 = computed(() =>
//   isMobile.value ? coinlistMImg3 : coinlistImg3
// );

const updateWindowSize = () => {
  resolutionStore.setSize({ width: window.innerWidth });
};

onMounted(() => {
  window.addEventListener("resize", updateWindowSize);
});

onUnmounted(() => {
  window.removeEventListener("resize", updateWindowSize);
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pages/explanation/common_explanation.scss";
</style>
